import {
  CHOOSE_MONSTER,
  CLEAR_MONSTER_SEARCH,
  FETCH_MONSTER_BEGIN,
  FETCH_MONSTER_FAILURE,
  FETCH_MONSTER_SUCCESS,
  MONSTER_SUGGEST_SUCCESS,
  REMOVE_MONSTER,
  UPDATE_MONSTER_SEARCH,
} from '../constants/action-types'

const initialState = {
  error: null,
  loading: false,
  loadedMonster: null,
  query: '',
  searchResults: [],     // array of suggestion objects from API
  selectedMonsters: [],  // array of suggestion objects chosen by user
}

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MONSTER_SEARCH:
      return {
        ...state,
        query: action.payload,
      }
    case MONSTER_SUGGEST_SUCCESS:
      return {
        ...state,
        searchResults: action.payload,
      }
    case CHOOSE_MONSTER:
      return {
        ...state,
        query: '',
        searchResults: [],
        selectedMonsters: [...state.selectedMonsters, action.payload],
      }
    case CLEAR_MONSTER_SEARCH:
      return {
        ...state,
        query: '',
        searchResults: [],
      }
    case REMOVE_MONSTER:
      return {
        ...state,
        selectedMonsters: state.selectedMonsters.filter(m => m.game_id !== action.payload),
      }
    case FETCH_MONSTER_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_MONSTER_SUCCESS:
      return {
        ...state,
        loading: false,
        loadedMonster: action.payload,
      }
    case FETCH_MONSTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
